import React from 'react';
import * as MuiIcons from '@mui/icons-material';
import './BlankPage.css';

export interface MenuIconsProps {
    iconName?: string;
    size?: 'small' | 'medium' | 'large';
}

const MenuIcons: React.FC<MenuIconsProps> = ({ iconName, size = 'medium' }) => {
    const IconComponent = (MuiIcons as any)[iconName || 'DashboardCustomizeOutlined'] || MuiIcons.StarOutlineOutlined;
    return <IconComponent fontSize={size} />;
};
export default MenuIcons;
